import router from '../router';
import { authStore } from '../store/auth';

// Wraps fetch() so every authenticated backend call carries the current
// JWT and an expired/invalid token (401 from AuthorisationMiddleware) bounces
// the user back to /login instead of failing silently.
export async function authFetch(url, options = {}) {
  const token = authStore.getToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    authStore.logout();
    router.push('/login');
  }

  return response;
}
